import React from 'react';
import { Container, Typography, Link, Box, Paper } from '@mui/material';
import LoginLayout from '../../components/layout/LoginLayout';
import { DEFAULT_THEME } from '../../constants/themeDefaults';

export const CreditsPage: React.FC = () => {
    const theme = DEFAULT_THEME;
    
    return (
        <LoginLayout>
            <Container maxWidth="md" sx={{ py: 8 }}>
                <Paper elevation={0} sx={{ p: 4, bgcolor: 'transparent' }}>
                    <Typography variant="h4" component="h1" gutterBottom color={theme.textColor}>
                        Image Credits & Attributions
                    </Typography>
                    
                    <Box sx={{ mt: 4 }}>
                        <Typography variant="h6" gutterBottom color={theme.textColor}>
                            Login Page Image
                        </Typography>
                        <Typography variant="body1" paragraph>
                            "Punakaiki Coast" by{' '}
                            <Link 
                                href="https://www.flickr.com/photos/treegrow/31055671317/"
                                target="_blank"
                                rel="noopener noreferrer"
                                sx={{ color: theme.navigationColor }}
                            >
                                Katja Schulz
                            </Link>
                            {' '}is licensed under CC BY 2.0
                        </Typography>
                    </Box>

                    <Box sx={{ mt: 4 }}>
                        <Typography variant="h6" gutterBottom color={theme.textColor}>
                            Registration Page Image
                        </Typography>
                        <Typography variant="body1" paragraph>
                            "Toi Toi grass" by{' '}
                            <Link 
                                href="https://www.flickr.com/photos/tomas_sobek/7412824206/"
                                target="_blank"
                                rel="noopener noreferrer"
                                sx={{ color: theme.navigationColor }}
                            >
                                Tomas Sobek
                            </Link>
                            {' '}is licensed under CC BY 2.0
                        </Typography>
                    </Box>

                    <Box sx={{ mt: 4 }}>
                        <Typography variant="body2" color="text.secondary">
                            All images are used in accordance with their respective licenses. 
                            If you believe any content is being used inappropriately, please contact us.
                        </Typography>
                    </Box>
                </Paper>
            </Container>
        </LoginLayout>
    );
}; 